/**
 * Assistente do chat, somente leitura (ADR-0077, decisão 8 — Fase C).
 *
 * Responde sobre o dado do ERP (material, sobra, requisição) usando as mesmas
 * consultas dos comandos `/`, só nas telas que a pessoa abre. Mostra de onde
 * tirou (fontes) e quantas perguntas a unidade ainda tem hoje. A conversa com
 * o assistente é só de quem pergunta: não vira mensagem de ninguém.
 */
import { useState } from "react";

import { perguntarAoAssistente } from "../../services/chat";
import { Modal } from "./Dialogos";

export function Assistente({ request, aoFechar }) {
  const [pergunta, setPergunta] = useState("");
  const [historico, setHistorico] = useState([]);
  const [pensando, setPensando] = useState(false);

  const perguntar = async () => {
    const texto = pergunta.trim();
    if (!texto || pensando) return;
    setPensando(true);
    try {
      const r = await perguntarAoAssistente(request, texto);
      setHistorico((h) => [...h, { pergunta: texto, ...r }]);
      setPergunta("");
    } catch (erro) {
      setHistorico((h) => [...h, { pergunta: texto, erro: erro?.payload?.erro || erro?.message || "O assistente não respondeu." }]);
    } finally {
      setPensando(false);
    }
  };

  const ultima = historico[historico.length - 1];
  return (
    <Modal open titulo="Assistente do chat" aoFechar={aoFechar}>
      <p className="pchat-ajuda">Pergunte sobre estoque, sobras e requisições — por exemplo "quanto tem de Branco TX 15?". Ele só consulta: não reserva, não compra, não muda nada.</p>
      <div className="pchat-assistente">
        {historico.map((h, i) => (
          <div key={i} className="item">
            <div className="pergunta">{h.pergunta}</div>
            {h.erro ? <div className="resposta erro" role="alert">{h.erro}</div> : (
              <div className="resposta">
                {h.resposta}
                {h.fontes?.length > 0 && <small className="fontes">Fonte: {h.fontes.map((f) => `/${f.tipo} ${f.titulo}`).join(" · ")}</small>}
              </div>
            )}
          </div>
        ))}
        {pensando && <div className="resposta">Consultando…</div>}
      </div>
      <div className="pchat-modal-acoes">
        <input
          className="pchat-busca" placeholder="Sua pergunta" value={pergunta} maxLength={500} autoFocus
          onChange={(e) => setPergunta(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") perguntar(); }}
          aria-label="Pergunta ao assistente"
        />
        <button type="button" className="pchat-btn enviar texto" disabled={!pergunta.trim() || pensando} onClick={perguntar}>Perguntar</button>
      </div>
      {ultima && ultima.restantes !== undefined && <small className="pchat-ajuda">A unidade ainda pode fazer {ultima.restantes} pergunta(s) hoje.</small>}
    </Modal>
  );
}
